import { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
//Route
import RouteGuard from "./utils/RouteGuard";
// Common
import LoginPage from "./pages/login/LoginPage";
import ForgotPassword from "./pages/login/ForgotPassword";
import ResetPassword from "./pages/login/ResetPassword";
import ProfilePage from "./pages/login/profilePage";
import Error from "./pages/404/ErrorPage";
import MasterLayout from "./pages/MasterLayout/MasterLayout";
// Pages
import DashboardPage from "./pages/dashboard/DashboardPage";
import UserPage from "./pages/user/UserPage";
import CreateUserPage from "./pages/user/CreateUserPage";
import EditUserPage from "./pages/user/EditUserPage";
import { api } from "./utils/apiClient";
import { useDispatch } from "react-redux";
import { setPermissions } from "./redux/slice/permissions";
import { setProfileInfo } from "./redux/slice/getProfileInfo";
import FullPageLoader from "./utils/FullPageLoader";
import useLogout from "./pages/login/Logout";
import SettingsPage from "./pages/settings/SettingsPage";
import RouteScrollToTop from "./utils/RouteScrollToTop";
import EventPage from "./pages/events/event";
import EventFormPage from "./pages/events/eventFromPage";
import RolePermissionTable from "./pages/role";
import ViewRoles from "./pages/role/ViewRoles";
import RoleForm from "./pages/role/RoleForm";


function App() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const logout = useLogout();
  const location = useLocation();
  

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        setLoading(true);
        const res = await api.get("/profile");
        const perms = res?.data?.data?.permissions.map(p => p.name);
        const profile = res?.data?.data.user;
        dispatch(setPermissions(perms));
        dispatch(setProfileInfo(profile));
      } catch (err) {
        console.error("Get Profile Error:", err);
        if (err?.response?.status === 401) {
          logout(false);
        }
      } finally {
        setLoading(false);
        localStorage.removeItem("showDashboardLoader");
      }
    };

    const token = localStorage.getItem("token");
    if (!token) return;

    fetchProfile();
  }, [dispatch, logout]);


  // if (loading) return <FullPageLoader />;
  const showDashboardLoader =
    loading &&
    location.pathname === "/dashboard" &&
    localStorage.getItem("showDashboardLoader") === "true";

  if (showDashboardLoader) {
    return <FullPageLoader />;
  }

  return (
    <>
      <ToastContainer position={"top-left"} autoClose={2500} />
      <RouteScrollToTop />

      <div>
        <Routes>

          {/* ===================== Login ===================== */}
          <Route path="/"
            element={
              <RouteGuard type="login">
                <LoginPage />
              </RouteGuard>
            }
          />
          <Route path="/forgot-password"
            element={
              <RouteGuard type="login">
                <ForgotPassword />
              </RouteGuard>
            }
          />

          <Route path="/reset-password"
            element={
              <RouteGuard type="login">
                <ResetPassword />
              </RouteGuard>
            }
          />

          {/* ===================== 404 Page ===================== */}
          <Route path="*" element={<Error />} />

          {/* ===================== Dashboard ===================== */}
          <Route
            path="/dashboard"
            element={
              <RouteGuard type="auth">
                <MasterLayout>
                  <DashboardPage />
                </MasterLayout>
              </RouteGuard>
            }
          />

    
          {/* ===================== Users ===================== */}
          <Route
            path="/users"
            element={
              <RouteGuard type="protected" permission="user.view">
                <MasterLayout>
                  <UserPage />
                </MasterLayout>
              </RouteGuard>
            }
          />

          <Route
            path="/create-user"
            element={
              <RouteGuard type="protected" permission="user.create">
                <MasterLayout>
                  <CreateUserPage />
                </MasterLayout>
              </RouteGuard>
            }
          />

          <Route
            path="/edit-user/:id"
            element={
              <RouteGuard type="protected" permission="user.edit">
                <MasterLayout>
                  <EditUserPage />
                </MasterLayout>
              </RouteGuard>
            }
          />

          {/* ===================== Role Permission ===================== */}
          <Route
            path="/roles"
            element={
              <RouteGuard type="protected" permission="role.view">
                <MasterLayout>
                  <RolePermissionTable />
                </MasterLayout>
              </RouteGuard>
            }
          />

          <Route
            path="/roles/:id"
            element={
              <RouteGuard type="protected" permission="role.view">
                <MasterLayout>
                  <ViewRoles />
                </MasterLayout>
              </RouteGuard>
            }
          />

          <Route
            path="/roles/edit/:id"
            element={
              <RouteGuard type="protected" permission="role.edit">
                <MasterLayout>
                  <RoleForm mode="edit" />
                </MasterLayout>
              </RouteGuard>
            }
          />

          <Route
            path="/create-roles"
            element={
              <RouteGuard type="protected" permission="role.create">
                <MasterLayout>
                  <RoleForm mode="create" />
                </MasterLayout>
              </RouteGuard>
            }
          />

          {/* SettingsPage */}
          <Route
            path="/settings"
            element={
              <RouteGuard type="protected" permission="settings.view">
                <MasterLayout>
                  <SettingsPage />
                </MasterLayout>
              </RouteGuard>
            }
          />


          {/* ===================== myprofile ===================== */}
          <Route
            path="/myprofile"
            element={
              <RouteGuard type="protected" permission="user.view">
                <MasterLayout>
                  <ProfilePage />
                </MasterLayout>
              </RouteGuard>
            }
          />

          {/* ===================== INVENTORY ===================== */}
          <Route
            path="/events"
            element={
              <RouteGuard type="protected" permission="event.view">
                <MasterLayout>
                  <EventPage />
                </MasterLayout>
              </RouteGuard>
            }
          />

          {/* Inventory create (no ID) */}
          <Route
            path="/events-form"
            element={
              <RouteGuard type="protected" permission="event.create">
                <MasterLayout>
                  <EventFormPage />
                </MasterLayout>
              </RouteGuard>
            }
          />

          {/* Inventory edit (with ID param) */}
          <Route
            path="/events-form/:id"
            element={
              <RouteGuard type="protected" permission="event.edit">
                <MasterLayout>
                  <EventFormPage />
                </MasterLayout>
              </RouteGuard>
            }
          />





        </Routes>
      </div >
    </>
  );
}

export default App;